import {
  call, put, select, takeEvery, takeLeading,
} from 'redux-saga/effects';
import {
  ADD_MRD_REQUEST, ASSOCIATE_HANDLER_REQUEST,
  EDIT_MRD_REQUEST, GET_ACTIVE_MRD_LIST_REQUEST,
  GET_MRD_FORM_FIELDS,
  FETCH_INBOUND_DATA_LOCATION_LIST_REQUEST,
} from '../actions/types/DeviceInformationActionTypes';
import {
  editMrdFailureActionCreator,
  editMrdSuccessActionCreator,
  getMrdStatusesSuccessActionCreator,
  getMrdTypesSuccessActionCreator,
  getPostalOperatorsSuccessActionCreator,
  getMrdStatusesFailureActionCreator,
  getMrdTypesFailureActionCreator,
  getPostalOperatorsFailureActionCreator,
  addMrdFailureActionCreator,
  addMrdSuccessActionCreator,
  setAddMrdSuccessStatusActionCreator,
  setAssociateHandlerSuccessStatusActionCreator,
  associateHandlerSuccessActionCreator,
  associateHandlerFailureActionCreator,
  getActiveMrdListSuccessActionCreator,
  getActiveMrdListFailureActionCreator,
  getInboundDataLocationsSuccessActionCreator,
  getInboundDataLocationsFailureActionCreator,
} from '../actions/DeviceInformationActions';
import {
  apiFetchActiveMrdTypes, apiFetchInboundDataLocationList,
  apiFetchMrdList,
  apiFetchMrdStatuses,
  apiFetchPostalOperatorList,
} from '../../api/DeviceInformationAPI';
import { languageSelector } from '../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../common/notifications/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../locales/locales';
import { apiEditMrd } from '../../edit-mrd/api/EditMrdAPI';
import { apiAddMrd } from '../../add-mrd/api/AddMrdAPI';
import { apiPostAssociateHandlerDefault } from '../../associate-handler/api/AssociateHandlerAPI';

function* getMrdStatusesWorker(action) {
  try {
    const res = yield call(apiFetchMrdStatuses, action.payload);
    yield put(getMrdStatusesSuccessActionCreator(res.data));
  } catch (error) {
    yield put(getMrdStatusesFailureActionCreator(error));
  }
}

function* getMrdTypesWorker(action) {
  try {
    const res = yield call(apiFetchActiveMrdTypes, action.payload);
    yield put(getMrdTypesSuccessActionCreator(res.data));
  } catch (error) {
    yield put(getMrdTypesFailureActionCreator(error));
  }
}

function* getPostalOperatorsWorker(action) {
  try {
    const res = yield call(apiFetchPostalOperatorList, action.payload);
    yield put(getPostalOperatorsSuccessActionCreator(res.data));
  } catch (error) {
    yield put(getPostalOperatorsFailureActionCreator(error));
  }
}

function* editMrdWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiEditMrd, action.payload);
    yield put(editMrdSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.mrd.edit.success'),
    }));
  } catch (error) {
    yield put(editMrdFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: error.response.data.message || formatMessage(lang, 'notification.mrd.edit.failure'),
    }));
  }
}

function* addMrdWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiAddMrd, action.payload);
    yield put(addMrdSuccessActionCreator(res.data));
    yield put(setAddMrdSuccessStatusActionCreator(true));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.mrd.add.success'),
    }));
  } catch (error) {
    yield put(addMrdFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: error.response.data.message || formatMessage(lang, 'notification.mrd.add.failure'),
    }));
  }
}

function* associateHandlerWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiPostAssociateHandlerDefault, action.payload);
    yield put(associateHandlerSuccessActionCreator(res.data));
    yield put(setAssociateHandlerSuccessStatusActionCreator(true));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.mrd.associate.handler.success'),
    }));
  } catch (error) {
    yield put(associateHandlerFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: error.response.data.message || formatMessage(lang, 'notification.mrd.associate.handler.failure'),
    }));
  }
}

function* getActiveMrdListWorker(action) {
  try {
    const res = yield call(apiFetchMrdList, action.payload);
    yield put(getActiveMrdListSuccessActionCreator(res.data));
  } catch (error) {
    yield put(getActiveMrdListFailureActionCreator(error));
  }
}

function* getInboundDataLocationListWorker(action) {
  try {
    const res = yield call(apiFetchInboundDataLocationList, action.payload);
    yield put(getInboundDataLocationsSuccessActionCreator(res.data));
  } catch (error) {
    yield put(getInboundDataLocationsFailureActionCreator(error));
  }
}

function* deviceInformationWatcher() {
  yield takeEvery(GET_MRD_FORM_FIELDS, getMrdStatusesWorker);
  yield takeEvery(GET_MRD_FORM_FIELDS, getMrdTypesWorker);
  yield takeEvery(GET_MRD_FORM_FIELDS, getPostalOperatorsWorker);
  yield takeLeading(EDIT_MRD_REQUEST, editMrdWorker);
  yield takeLeading(ADD_MRD_REQUEST, addMrdWorker);
  yield takeLeading(ASSOCIATE_HANDLER_REQUEST, associateHandlerWorker);
  yield takeEvery(GET_ACTIVE_MRD_LIST_REQUEST, getActiveMrdListWorker);
  yield takeEvery(FETCH_INBOUND_DATA_LOCATION_LIST_REQUEST, getInboundDataLocationListWorker);
}

export default deviceInformationWatcher;
export {
  getMrdStatusesWorker,
  getMrdTypesWorker,
  getPostalOperatorsWorker,
  editMrdWorker,
  addMrdWorker,
  associateHandlerWorker,
  getActiveMrdListWorker,
  getInboundDataLocationListWorker,
};
